import { makeApiUrl, makeHttpClient } from '~/main/factories/http';
import { SendClinicalDocs as UseCaseRemoteSendClinicalDocs } from '~/domain/usecases/clinicalDocs/remote';

import { RemoteSendClinicalDocs } from '~/data/repository/clinicalDocs';

export const makeRemoteSendClinicalDocs = (): UseCaseRemoteSendClinicalDocs =>
  new RemoteSendClinicalDocs(makeApiUrl('/clinicalDocs'), makeHttpClient());
